import { commonService } from '.';

const addEducation = (body) => {
    return commonService.post('Education/add', body);
};

const getEducationByDc = (body) => {
    return commonService.getWithParam('Education/getByDc', body);
};

const deleteEducation = (id, idDc, idLang) => {
    return commonService.deleteWithParam('Education?id=' + id + '&idDc=' + idDc + '&idLang=' + idLang, null);
};

const updateEducation = (body) => {
    return commonService.put('Education/update', body);
};

export const educationService = {
    addEducation,
    getEducationByDc,
    deleteEducation,
    updateEducation
};
